import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import CRETable1 from './Components/GeneracionFactura/CRETable1'
import SEFooter from './Components/GeneracionFactura/CREFooter'
import {actionComprobanteRetencionEmision, actionsLogin} from '../../actions/action-creators'
import CREModalsGeneracion from './Components/GeneracionFactura/Modals/CREModalsGeneracion'
import CREEncabezado from './Components/CREEncabezado'
import CREDatosCliente from './Components/GeneracionFactura/CREDatosCliente'
import CREDatosProducto from './Components/GeneracionFactura/CREDatosProducto'
import { BannerElegirSucursal } from '../../components/Banner/BannerElegirSucursal'
import { setActiveModuleDoc } from '../../actions/documentos/documentos.actions'
import DocumentosReceptor from '../../components/DocumentoReceptor/DocumentosReceptor'
import { validateHorarioSucursal, validateUsoModulo } from '../../actions/general.actions'

const GeneracionComprobanteRetencion = () => {
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionComprobanteRetencionEmision, dispatch)
  const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)

  useEffect(() => {  
    dispatch(validateUsoModulo());
    dispatch(validateHorarioSucursal())
    dispatch(setActiveModuleDoc({idDoc: '7', title: 'Comprobante Retención'})); 
    getSucursales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSucursales = async () => {
    suscripcionGetFacturasDisponibles()
    await actions.comprobanteRetencionPostSucursales()
  }

  return (<><CREModalsGeneracion />
      <CREEncabezado url='/otros-documentos' />
      <BannerElegirSucursal />
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='dos-columnas-resp'>
            <CREDatosCliente />
            <CREDatosProducto />
          </div>
        </div>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'><div className='w-layout-vflex card-content'><CRETable1 /></div></div>
        </div>
        <DocumentosReceptor />
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card'><div className='w-layout-vflex card-content'><SEFooter /></div></div>
        </div>
      </div></>)
}

export default GeneracionComprobanteRetencion
